import { render, staticRenderFns } from "./dataQCModal.vue?vue&type=template&id=e21e7300&scoped=true&"
import script from "./dataQCModal.vue?vue&type=script&lang=js&"
export * from "./dataQCModal.vue?vue&type=script&lang=js&"
import style0 from "./dataQCModal.vue?vue&type=style&index=0&id=e21e7300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21e7300",
  null
  
)

export default component.exports